export default __webpack_public_path__ + "static/media/video.5ea8cc3b.mp4";